import React from 'react'
import Edit from '../../crud/edit'
import fields from '../fields'
import menuItems from '../menuItems'

const EditInsitution = ({ params }) => (
  <Edit
// @ts-ignore
    title='Edit Institution'
    fields={fields}
    apiPath={`admin/institutions/${params.institutionId}`}
    successRedirectPath='/membership/institutions'
    buildMenuItems={menuItems}
  />
)

export default EditInsitution
